import { EmployeeSkillsService } from '../../services/employeeSkills.service';
import { employeesItemComponent } from './employees/employees.item.component';
import { employeesListComponent } from './employees/employees.list.component';
import { employeesComponent } from './employees/employees.component';
import { hrDashboardComponent } from './hr.dashboard.component';
import { hrComponent } from './hr.component';
import { employeesItemState, employeesListState, employeesState, hrDashboardState, hrState, availabilityListState, applicantsState, applicantsListState, applicantsItemState, applicantsItemBasicState, applicantsItemEmployeeState, applicantsArchiveState, applicantsArchiveItemState, applicantsArchiveItemBasicState } from './hr.states';
import { employeesItemBasicState, shiftsItemState, availabilityItemState, skillsItemState } from './hr.states';
import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { EmployeesService, ShiftService, DeclarationService, NmbrsService, ApplicantsService, ApplicantStatusHistoryService } from "../../services/index";
import { SalaryScaleGroupService, SalaryScaleService } from "../../services/salaryScaleGroup.service";
import { employeesItemBasicComponent } from "./employees/employees.item.basic.component";
import { shiftsListComponent } from "./shifts/shifts.list.component";
import { shiftsItemComponent } from "./shifts/shifts.item.component";
import { availabilityCalendarComponent } from "./availability/availability.calendar.component";
import { availabilityItemComponent } from "./availability/availability.item.component";
import { skillsListComponent } from "./skills/skills.list.component";
import { skillsItemComponent } from "./skills/skills.item.component";
import { uploaderComponent } from "../shared/uploader.component";
import { nmbrsComponent } from "./nmbrs/nmbrs.component";
import { availabilityListComponent } from './availabilityList/availabilityList.component';
import { applicantsItemComponent } from './applicants/applicants.item.component';
import { applicantsListComponent } from './applicants/applicants.list.component';
import { applicantsComponent } from './applicants/applicants.component';
import { applicantsItemBasicComponent } from "./applicants/applicants.item.basic.component";
import { applicantsItemEmployeeComponent } from "./applicants/applicants.item.employee.component";

const hrAppModule: aboTheme.INgModule = {
    components: { hrComponent, hrDashboardComponent,
        employeesComponent, employeesListComponent, employeesItemComponent,
        employeesItemBasicComponent, shiftsListComponent, shiftsItemComponent,
        availabilityCalendarComponent, availabilityItemComponent,
        skillsListComponent, skillsItemComponent, uploaderComponent,
        nmbrsComponent,
        availabilityListComponent,
        applicantsComponent, applicantsListComponent, applicantsItemComponent, applicantsItemBasicComponent, applicantsItemEmployeeComponent
    },
    states: [ hrState, hrDashboardState,
        employeesState, employeesListState, employeesItemState,
        employeesItemBasicState, shiftsItemState, availabilityItemState,
        skillsItemState,
        availabilityListState,
        applicantsState, applicantsListState, applicantsItemState, applicantsItemBasicState, applicantsItemEmployeeState, applicantsArchiveState, applicantsArchiveItemState, applicantsArchiveItemBasicState
    ],
    services: { EmployeesService, ShiftService, DeclarationService, EmployeeSkillsService, NmbrsService, ApplicantsService, ApplicantStatusHistoryService, SalaryScaleGroupService, SalaryScaleService }
};

loadNg1Module(ngmodule, hrAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/hr/index.ts